<ng-scrollbar appearance="standard">
  <mat-nav-list class="navigation-list min-width-250 pr-20">
    <ng-container *ngFor="let item of items$ | async">
      <app-menu-list-item [item]="item"></app-menu-list-item>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-nav-list>
</ng-scrollbar>
